import { UnitType } from '@qfa/forms';
import { UserContext } from 'contexts';
import { useContext, useMemo } from 'react';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import { useUserTenantPreference } from './preferences';

export interface UnitPreference {
  unit: UnitType;
}

export const useUnitPreference = () => {
  const { unit } = useContext(UserContext);

  const { value: preference } = useUserTenantPreference<UnitPreference>({
    key: PREFERENCE_KEYS.UNIT,
  });

  const userUnit = useMemo(() => ({ unit: preference.unit || unit }), [unit, preference.unit]);

  return userUnit;
};
